Auth = require 'db/auth'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
l = require 'lib/localize'
Member = undefined
queueRequire -> Member = require 'models/member'
MemberAccountView = undefined
queueRequire -> MemberAccountView = require 'views/member/member-account-view'
MemberBillingView = undefined
queueRequire -> MemberBillingView = require 'views/member/member-billing-view'
MemberBoardsView = undefined
queueRequire -> MemberBoardsView = require 'views/member/member-boards-view'
MemberCardsView = undefined
queueRequire -> MemberCardsView = require 'views/member/member-cards-view'
MemberNotificationsView = undefined
queueRequire -> MemberNotificationsView = require 'views/member/member-notifications-view'
MemberProfileView = undefined
queueRequire -> MemberProfileView = require 'views/member/member-profile-view'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
updateTimezone = require 'lib/update-timezone'
$ = require 'jquery'
log = require 'debug/log'
_ = require 'underscore'
assert = require 'lib/assert'
ApiError = require 'network/api-error'
simpleTest = require 'lib/experiments/simple-test'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'
Util = require 'lib/util'

# Variables used to determine if we should pretend the user is new, for testing
# purposes
simulateNewUser = null

module.exports =
  routes: [
    ['', 'memberBoardsView']
    [':username/cards', 'memberCardsView']
    [':username/cards/:orgname', 'memberCardsView']
    [':username/notifications', 'memberNotificationsView']
  ]

  displayMemberPage: (settings) ->
    { username, loadFn, viewClass, getLocation, bodyClass, product, orgname, titleKey } = settings
    username ?= Auth.myUsername()

    log('controller', ['memberBoardsView'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', loadFn, username
      .then (member) =>
        simulateNewUser ?= $.cookie('simulateNewUser')

        memberHasNoBoards = member.boardList.length == 0 ||
          (member.boardList.length == 1 && member.boardList.models[0].isWelcomeBoard())

        isNewUser = simulateNewUser ||
          Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 })

        if viewClass == MemberBoardsView && isNewUser && memberHasNoBoards && simpleTest('skipBoardsPage').get('enabled')
          return @redirectToFirstBoard(member)

        @clearPreviousView()

        if Auth.isMe(member) && viewClass == MemberBoardsView
          @setViewType("home")
        else
          @setViewType(member)

        title =
          if Auth.isMe(member) && titleKey?
            l(['page title', titleKey])
          else
            "#{member.get('fullName')} (#{member.get('username')})"

        # Do this before creating the view, in case the view has more
        # specific logic for setting the URL
        @setLocation
          title: title
          location: getLocation.call(@, member.get('username'), product)
          options:
            replace: true

        options = { product, orgname, modelCache: ModelCache }

        memberView = @topLevelView(viewClass, member, options)
        @showHeader()
        @maybeShowFooterChrome(@getMemberBoardsUrl())

        if bodyClass
          $('body').addClass(bodyClass)
        else
          $('body').addClass('body-tabbed-page')

        $('#content').html(memberView.render().el)
        @focusContent()
        memberView.getData?()

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  redirectToFirstBoard: (member) ->
    createDefaultLists = !simpleTest('guidedSteps').get('enabled')

    # Data that we'll use in the body of the POST to create the board
    initialData =
      name: l(['untitled board'])

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      defaultLists: createDefaultLists
    }, initialData)

    newBoard = member.boardList.create initialData, {
      requestData: requestData
      success: (board) =>

        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        @displayBoard({
          idBoard: board.id
          openListComposer: !createDefaultLists
          openCardComposerInFirstList: createDefaultLists
        }).done()

        return
      error: =>
        @displayErrorPage()
    }

    return

  memberBoardsView: ->
    if !Auth.isLoggedIn()
      # Hopefully you're not being routed here if you aren't logged in and
      # the server is sending you to the home page
      return @displayErrorPage()

    # If you're logged in, always kick you to your own boards page, since you
    # can't see anyone elses
    simulateNewUser ?= $.cookie('simulateNewUser')
    opts =
      username: 'me'
      loadFn: 'loadMemberBoardsData'
      viewClass: MemberBoardsView
      getLocation: @getMemberBoardsUrl
      titleKey: 'boards'

    @displayMemberPage(opts).then(updateTimezone).done()

    if( simulateNewUser || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
      trackGoogleTagManager.possibleNewSignup()

  memberNotificationsView: (username = 'me') ->
    if !Auth.isLoggedIn()
      return @displayErrorPage()

    # If you're logged in, always kick you to your own notifications page,
    # since you can't see anyone else's
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadNotificationData'
      viewClass: MemberNotificationsView
      getLocation: @getMemberNotificationsUrl
      titleKey: 'notifications'
    .done()

  memberProfileView: (username = 'me') ->
    @displayMemberPage
      username: username,
      loadFn: 'loadMemberProfileData'
      viewClass: MemberProfileView
      getLocation: @getMemberProfileUrl
      titleKey: 'profile'
    .done()

  memberCardsView: (username = 'me', orgname) ->
    @displayMemberPage
      username: username
      loadFn: 'loadMemberCardsData'
      viewClass: MemberCardsView
      getLocation: (username) =>
        @getMemberCardsUrl(username, orgname)
      titleKey: 'cards'
      orgname: orgname
    .done()

  memberAccountView: (username) ->
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadMemberAccountData'
      viewClass: MemberAccountView
      getLocation: @getMemberAccountUrl
      titleKey: 'settings'
    .done()

  memberBillingView: (username) ->
    username = 'me'
    @displayMemberPage
      username: username
      loadFn: 'loadMemberAccountData'
      viewClass: MemberBillingView
      getLocation: @getMemberBillingUrl
      titleKey: 'billing'
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/member-routes.coffee